// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Side bar */
/* Add shadows into the element */
/* Container with a column direction */
.row-layout {
  display: flex;
  flex-direction: row;
  height: 100%;
}

/* Container with a column direction */
.column-layout {
  display: flex;
  flex-direction: column;
  width: 100%;
}

/* Item style for empty lists */
.notification-label {
  display: flex;
  justify-content: center;
  padding: 1rem;
  gap: 8px;
}

.left-panel-tree {
  width: 100%;
  margin: 0px;
  padding: 0px;
  background: var(--ion-card-background);
}

ion-item {
  height: -moz-fit-content;
  height: fit-content;
  font-size: small;
  padding: 0px;
  margin: 0px;
}

.info-header-item {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 7px 8px 7px 6px;
  gap: 8px;
  background: rgba(var(--ion-color-primary-rgb), 0.06);
  border-left: 3px solid var(--ion-color-primary);
  border-bottom: 1px solid rgba(var(--ion-color-primary-rgb), 0.15);
  cursor: pointer;
  overflow: hidden;
}

.info-caret {
  flex: 0 0 16px;
  font-size: 14px;
  color: var(--ion-color-primary);
}

.info-header-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 26px;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background: rgba(var(--ion-color-primary-rgb), 0.14);
}
.info-header-icon-wrap ion-icon {
  font-size: 14px;
  color: var(--ion-color-primary);
}

.info-header-texts {
  display: flex;
  flex-direction: column;
  gap: 1px;
  flex: 1;
  min-width: 0;
}

.info-header-eyebrow {
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--ion-color-primary);
  white-space: nowrap;
}

.info-header-name {
  font-size: 11px;
  font-weight: 600;
  color: var(--ion-color-dark);
  white-space: nowrap;
}

.info-header-action {
  flex: 0 0 auto;
  height: 24px;
  font-size: 11px;
  font-weight: 700;
  --padding-start: 8px;
  --padding-end: 8px;
  margin: 0;
}

.info-form-content {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 8px;
  background: rgba(var(--ion-color-light-rgb), 0.4);
  border-bottom: 1px solid rgba(var(--ion-color-primary-rgb), 0.08);
}

.info-fields-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px;
}

.info-field {
  display: flex;
  flex-direction: column;
  gap: 2px;
  background: var(--ion-background-color, #fff);
  border: 1px solid rgba(var(--ion-text-color-rgb), 0.1);
  border-radius: 6px;
  padding: 5px 8px 5px;
  border-left: 3px solid rgba(var(--ion-color-primary-rgb), 0.35);
}

.info-field-label {
  font-size: 8px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--ion-color-medium);
  line-height: 1;
}

.info-field-input {
  font-size: 13px;
  font-weight: 500;
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: 0;
  --padding-bottom: 0;
  --color: var(--ion-color-dark);
  min-height: 22px;
}

.defaults-section {
  padding: 6px 8px;
  background: rgba(var(--ion-color-light-rgb), 0.5);
  border-bottom: 1px solid rgba(var(--ion-text-color-rgb), 0.07);
}
.defaults-section .info-fields-row {
  grid-template-columns: 1fr;
}

.defaults-header {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--ion-color-medium);
  margin-bottom: 5px;
}
.defaults-header ion-icon {
  font-size: 12px;
}

ion-grid {
  height: 100%;
  width: 100%;
  margin: 0px;
  padding: 0px;
  background: var(--ion-card-background);
}

ion-col {
  height: 100%;
  width: 100%;
  padding-left: var(--spacing-small);
  padding-right: var(--spacing-small);
}

ion-row {
  height: 100%;
  width: 100%;
}

ion-input.smallItem {
  font-weight: 500;
  width: 100%;
  font-size: var(--font-size-small);
  --color: var(--ion-text-color);
}

ion-input.largeItem {
  font-weight: 500;
  font-size: var(--font-size-small);
  width: 100%;
  --color: var(--ion-text-color);
}

.stage-indicator {
  display: flex;
  width: 100%;
  background: var(--ion-card-background);
  border-bottom: 1px solid var(--ion-border-color, rgba(var(--ion-text-color-rgb), 0.12));
  position: sticky;
  top: 0;
  z-index: 10;
}

.stage-tab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 6px 4px;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  font-size: var(--font-size-xx-small);
  color: var(--ion-color-medium);
  transition: color 0.15s, border-color 0.15s, background 0.15s;
  position: relative;
}
.stage-tab ion-icon {
  font-size: 14px;
}
.stage-tab .stage-tab-label {
  font-size: var(--font-size-xx-small);
  font-weight: 500;
  white-space: nowrap;
}
.stage-tab .stage-tab-count {
  position: absolute;
  top: 3px;
  right: 6px;
  background: var(--ion-color-medium);
  color: var(--ion-color-medium-contrast);
  border-radius: 8px;
  font-size: 9px;
  font-weight: 700;
  padding: 0 4px;
  line-height: 14px;
  min-width: 14px;
  text-align: center;
}
.stage-tab.active {
  color: var(--ion-text-color);
  border-bottom-color: currentColor;
  background: var(--ion-card-background);
}
.stage-tab.departure-tab.active {
  color: rgb(255, 89, 94);
}
.stage-tab.departure-tab.active .stage-tab-count {
  background: rgb(255, 89, 94);
  color: #fff;
}
.stage-tab.mission-tab.active {
  color: rgb(138, 201, 38);
}
.stage-tab.mission-tab.active .stage-tab-count {
  background: rgb(138, 201, 38);
  color: #fff;
}
.stage-tab.arrival-tab.active {
  color: rgb(50, 108, 235);
}
.stage-tab.arrival-tab.active .stage-tab-count {
  background: rgb(50, 108, 235);
  color: #fff;
}

.stage-section {
  border-bottom: 1px solid var(--ion-border-color, rgba(var(--ion-text-color-rgb), 0.08));
}

.stage-section-header {
  display: flex;
  align-items: center;
  padding: 4px var(--spacing-small);
  font-size: var(--font-size-xx-small);
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
}
.stage-section-header .stage-section-title {
  flex: 1;
}
.stage-section-header.departure-header {
  color: rgb(255, 89, 94);
  border-left: 3px solid rgb(255, 89, 94);
  background: rgba(255, 89, 94, 0.06);
}
.stage-section-header.mission-header {
  color: rgb(138, 201, 38);
  border-left: 3px solid rgb(138, 201, 38);
  background: rgba(138, 201, 38, 0.06);
}
.stage-section-header.arrival-header {
  color: rgb(50, 108, 235);
  border-left: 3px solid rgb(50, 108, 235);
  background: rgba(50, 108, 235, 0.06);
}
.stage-section-header .add-branch-btn {
  --padding-start: 4px;
  --padding-end: 4px;
  height: 24px;
}

.branch-header {
  display: flex;
  align-items: center;
  padding: 2px 4px 2px 8px;
  cursor: pointer;
  font-size: var(--font-size-xx-small);
  border-left: 3px solid transparent;
  transition: background 0.12s, border-color 0.12s;
}
.branch-header:hover {
  background: rgba(var(--ion-text-color-rgb), 0.04);
}
.branch-header .expand-icon {
  font-size: 10px;
  color: var(--ion-color-medium);
  flex-shrink: 0;
  margin-right: 4px;
  cursor: pointer;
}
.branch-header .branch-label {
  flex: 1;
  font-size: var(--font-size-xx-small);
  font-weight: 600;
  font-style: italic;
  --color: var(--ion-text-color);
  --padding-start: 0;
}
.branch-header.active-branch.departure-branch {
  border-left-color: rgb(255, 89, 94);
  background: rgba(255, 89, 94, 0.1);
}
.branch-header.active-branch.arrival-branch {
  border-left-color: rgb(50, 108, 235);
  background: rgba(50, 108, 235, 0.1);
}

.branch-items {
  padding-left: 12px;
}

.fork-group {
  margin: 2px 0;
}
.fork-group .fork-header {
  display: flex;
  align-items: center;
  padding: 3px 4px;
  cursor: pointer;
  font-size: var(--font-size-xx-small);
  border-radius: var(--border-radius-small);
  gap: 4px;
}
.fork-group .fork-header:hover {
  background: rgba(var(--ion-text-color-rgb), 0.04);
}
.fork-group .fork-header ion-icon {
  font-size: 10px;
  color: var(--ion-color-medium);
  flex-shrink: 0;
}
.fork-group .fork-header .fork-label {
  flex: 1;
  font-weight: 600;
  font-size: var(--font-size-xx-small);
  color: var(--ion-text-color);
}
.fork-group .fork-header ion-button {
  height: 22px;
  --padding-start: 2px;
  --padding-end: 2px;
}
.fork-group.departure-fork .fork-header {
  border-left: 2px dashed rgba(255, 89, 94, 0.5);
}
.fork-group.mission-fork .fork-header {
  border-left: 2px dashed rgba(138, 201, 38, 0.5);
}
.fork-group.arrival-fork .fork-header {
  border-left: 2px dashed rgba(50, 108, 235, 0.5);
}

.fork-items {
  padding-left: 14px;
}

.waypoint-row {
  border-bottom: 1px solid var(--ion-border-color, rgba(var(--ion-text-color-rgb), 0.06));
  transition: background 0.1s;
}
.waypoint-row:hover {
  background: rgba(var(--ion-text-color-rgb), 0.03);
}
.waypoint-row.departure-wp {
  border-left: 2px solid rgba(255, 89, 94, 0.3);
}
.waypoint-row.mission-wp {
  border-left: 2px solid rgba(138, 201, 38, 0.3);
}
.waypoint-row.arrival-wp {
  border-left: 2px solid rgba(50, 108, 235, 0.3);
}
.waypoint-row.fork-wp {
  border-left-width: 2px;
  border-left-style: dashed;
  opacity: 0.92;
}

.empty-stage-hint {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px var(--spacing-small);
  font-size: var(--font-size-xx-small);
  color: var(--ion-color-medium);
  font-style: italic;
}
.empty-stage-hint ion-icon {
  font-size: 14px;
  flex-shrink: 0;
}

/** Media queries **/
/*#region Small Screens*/
/* Styles for screens smaller than 800px wide or smaller than 550px high */
@media (max-width: 599px) {
  .stage-tab {
    padding: 4px 2px;
  }
  .stage-tab .stage-tab-label {
    display: none;
  }
  .stage-tab ion-icon {
    font-size: 16px;
  }
  .stage-section-header {
    padding: 3px var(--spacing-small);
    font-size: 9px;
  }
  .info-field {
    padding: 4px 6px;
  }
  .info-field-input {
    min-height: 18px;
    font-size: 11px;
  }
  .defaults-section {
    padding: 4px 6px;
  }
}
/*#endregion Small Screens*/
/*#region Medium Screens*/
/* Styles for medium screens with min-width of 800px and min-height of 550px */
@media (min-width: 600px) and (max-width: 1023px) {
  ion-accordion.accordion-collapsed ion-item[slot=header],
  ion-accordion.accordion-collapsing ion-item[slot=header] {
    height: -moz-fit-content;
    height: fit-content;
  }
  ion-accordion.accordion-collapsed ion-item[slot=header]::part(native),
  ion-accordion.accordion-collapsing ion-item[slot=header]::part(native) {
    height: 34px;
    min-height: -moz-fit-content;
    min-height: fit-content;
  }
  ion-accordion.accordion-expanded ion-item[slot=header],
  ion-accordion.accordion-expanding ion-item[slot=header] {
    height: -moz-fit-content;
    height: fit-content;
  }
  ion-accordion.accordion-expanded ion-item[slot=header]::part(native),
  ion-accordion.accordion-expanding ion-item[slot=header]::part(native) {
    height: 34px;
    min-height: -moz-fit-content;
    min-height: fit-content;
  }
  .info-field {
    padding: 5px 8px;
  }
  .info-field-input {
    min-height: 22px;
    font-size: 13px;
  }
  .stage-section-header {
    font-size: 10px;
  }
  .branch-header {
    padding: 3px 4px 3px 10px;
  }
  .defaults-section {
    padding: 6px 8px;
  }
}
/*#endregion Medium Screens*/
/*#region Larger Screens*/
/* Styles for screens larger than 1000px wide and 600px high */
@media (min-width: 1024px) {
  ion-accordion.accordion-collapsed ion-item[slot=header],
  ion-accordion.accordion-collapsing ion-item[slot=header] {
    height: -moz-fit-content;
    height: fit-content;
  }
  ion-accordion.accordion-collapsed ion-item[slot=header]::part(native),
  ion-accordion.accordion-collapsing ion-item[slot=header]::part(native) {
    height: 40px;
    min-height: -moz-fit-content;
    min-height: fit-content;
  }
  ion-accordion.accordion-expanded ion-item[slot=header],
  ion-accordion.accordion-expanding ion-item[slot=header] {
    height: -moz-fit-content;
    height: fit-content;
  }
  ion-accordion.accordion-expanded ion-item[slot=header]::part(native),
  ion-accordion.accordion-expanding ion-item[slot=header]::part(native) {
    height: 40px;
    min-height: -moz-fit-content;
    min-height: fit-content;
  }
  .info-header-inner {
    padding: 8px 10px 8px 12px;
  }
  .info-header-icon-wrap {
    width: 30px;
    height: 30px;
    flex: 0 0 30px;
  }
  .info-header-eyebrow {
    font-size: 10px;
  }
  .info-header-name {
    font-size: 13px;
    max-width: 150px;
  }
  .info-header-action {
    height: 28px;
    font-size: 12px;
  }
  .info-field {
    padding: 6px 10px;
  }
  .info-field-input {
    min-height: 26px;
    font-size: 14px;
  }
  .info-field-label {
    font-size: 9px;
  }
  .stage-tab {
    padding: 8px 6px;
  }
  .stage-tab ion-icon {
    font-size: 16px;
  }
  .stage-tab-label {
    font-size: 11px;
  }
  .stage-section-header {
    font-size: 11px;
    padding: 5px var(--spacing-small);
  }
  .branch-header {
    padding: 4px 6px 4px 12px;
  }
  .defaults-section {
    padding: 8px 10px;
  }
  .defaults-header {
    font-size: 10px;
  }
  .empty-stage-hint {
    font-size: 11px;
  }
}
/*#endregion Larger Screens*/`, "",{"version":3,"sources":["webpack://./src/custom-style.scss","webpack://./src/app/components/trajectory-creation/left-panel-tree/left-panel-tree.component.scss"],"names":[],"mappings":"AAIA,aAAA;AAiBA,iCAAA;AAOA,sCAAA;AACA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;ACzBJ;;AD4BA,sCAAA;AACA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;ACzBJ;;AD4BA,+BAAA;AACA;EACI,aAAA;EACA,uBAAA;EACA,aAAA;EACA,QAAA;ACzBJ;;AApBA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;AAuBF;;AApBA;EACI,wBAAA;EAAA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AAuBJ;;AAlBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,wBAAA;EACA,QAAA;EACA,oDAAA;EACA,+CAAA;EACA,iEAAA;EACA,eAAA;EACA,gBAAA;AAqBF;;AAlBA;EACE,cAAA;EACA,eAAA;EACA,+BAAA;AAqBF;;AAlBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oDAAA;AAqBF;AAnBE;EACE,eAAA;EACA,+BAAA;AAqBJ;;AAjBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;AAoBF;;AAjBA;EACE,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,+BAAA;EACA,mBAAA;AAoBF;;AAjBA;EACE,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,mBAAA;AAoBF;;AAjBA;EACE,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;AAoBF;;AAfA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,iDAAA;EACA,iEAAA;AAkBF;;AAfA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;AAkBF;;AAfA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,6CAAA;EACA,sDAAA;EACA,kBAAA;EACA,oBAAA;EACA,+DAAA;AAkBF;;AAfA;EACE,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,cAAA;AAkBF;;AAfA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAkBF;;AAbA;EACE,gBAAA;EACA,iDAAA;EACA,8DAAA;AAgBF;AAdE;EACE,0BAAA;AAgBJ;;AAZA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,kBAAA;AAeF;AAbE;EACE,eAAA;AAeJ;;AAVA;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;AAaF;;AAVA;EACE,YAAA;EACA,WAAA;EACA,kCAAA;EACA,mCAAA;AAaF;;AAVA;EACE,YAAA;EACA,WAAA;AAaF;;AAVA;EACE,gBAAA;EACA,WAAA;EACA,iCAAA;EACA,8BAAA;AAaF;;AAVA;EACE,gBAAA;EACA,iCAAA;EACA,WAAA;EACA,8BAAA;AAaF;;AARA;EACE,aAAA;EACA,WAAA;EACA,sCAAA;EACA,uFAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;AAWF;;AARA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,oCAAA;EACA,8BAAA;EACA,6DAAA;EACA,kBAAA;AAWF;AATE;EACE,eAAA;AAWJ;AARE;EACE,oCAAA;EACA,gBAAA;EACA,mBAAA;AAUJ;AAPE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,mCAAA;EACA,uCAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AASJ;AANE;EACE,4BAAA;EACA,iCAAA;EACA,sCAAA;AAQJ;AALE;EACE,uBAAA;AAOJ;AANI;EAAmB,4BAAA;EAA8B,WAAA;AAUrD;AARE;EACE,wBAAA;AAUJ;AATI;EAAmB,6BAAA;EAA+B,WAAA;AAatD;AAXE;EACE,wBAAA;AAaJ;AAZI;EAAmB,6BAAA;EAA+B,WAAA;AAgBtD;;AAVA;EACE,uFAAA;AAaF;;AAVA;EACE,aAAA;EACA,mBAAA;EACA,iCAAA;EACA,oCAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;AAaF;AAXE;EACE,OAAA;AAaJ;AAVE;EACE,uBAAA;EACA,uCAAA;EACA,mCAAA;AAYJ;AAVE;EACE,wBAAA;EACA,wCAAA;EACA,oCAAA;AAYJ;AAVE;EACE,wBAAA;EACA,wCAAA;EACA,oCAAA;AAYJ;AATE;EACE,oBAAA;EACA,kBAAA;EACA,YAAA;AAWJ;;AALA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,eAAA;EACA,oCAAA;EACA,kCAAA;EACA,gDAAA;AAQF;AANE;EACE,iDAAA;AAQJ;AALE;EACE,eAAA;EACA,8BAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AAOJ;AAJE;EACE,OAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,8BAAA;EACA,kBAAA;AAMJ;AAFI;EACE,mCAAA;EACA,kCAAA;AAIN;AAFI;EACE,oCAAA;EACA,mCAAA;AAIN;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,aAAA;AAAF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,oCAAA;EACA,yCAAA;EACA,QAAA;AAAJ;AAEI;EACE,iDAAA;AAAN;AAGI;EACE,eAAA;EACA,8BAAA;EACA,cAAA;AADN;AAII;EACE,OAAA;EACA,gBAAA;EACA,oCAAA;EACA,4BAAA;AAFN;AAKI;EACE,YAAA;EACA,oBAAA;EACA,kBAAA;AAHN;AAOE;EAAgC,8CAAA;AAJlC;AAKE;EAAgC,+CAAA;AAFlC;AAGE;EAAgC,+CAAA;AAAlC;;AAGA;EACE,kBAAA;AAAF;;AAKA;EACE,uFAAA;EACA,2BAAA;AAFF;AAIE;EACE,iDAAA;AAFJ;AAKE;EAAiB,6CAAA;AAFnB;AAGE;EAAiB,8CAAA;AAAnB;AACE;EAAiB,8CAAA;AAEnB;AAAE;EACE,sBAAA;EACA,yBAAA;EACA,aAAA;AAEJ;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iCAAA;EACA,oCAAA;EACA,8BAAA;EACA,kBAAA;AADF;AAGE;EACE,eAAA;EACA,cAAA;AADJ;;AAKA,oBAAA;AAEA,wBAAA;AAEA,0EAAA;AACA;EACE;IACE,gBAAA;EAJF;EAKE;IAAmB,aAAA;EAFrB;EAGE;IAAW,eAAA;EAAb;EAGA;IACE,iCAAA;IACA,cAAA;EADF;EAIA;IAAc,gBAAA;EADd;EAEA;IAAoB,gBAAA;IAAkB,eAAA;EAEtC;EADA;IAAoB,gBAAA;EAIpB;AACF;AAFA,2BAAA;AAEA,yBAAA;AAEE,8EAAA;AACA;EAEE;;IAEE,wBAAA;IAAA,mBAAA;EACJ;EACI;;IACE,YAAA;IACA,4BAAA;IAAA,uBAAA;EAEN;EAEE;;IAEE,wBAAA;IAAA,mBAAA;EAAJ;EAEI;;IACE,YAAA;IACA,4BAAA;IAAA,uBAAA;EACN;EAGE;IAAc,gBAAA;EAAhB;EACE;IAAoB,gBAAA;IAAkB,eAAA;EAGxC;EAFE;IAAwB,eAAA;EAK1B;EAJE;IAAiB,yBAAA;EAOnB;EANE;IAAoB,gBAAA;EAStB;AACF;AAPA,4BAAA;AAEA,yBAAA;AAEE,8DAAA;AACA;EAEE;;IAEE,wBAAA;IAAA,mBAAA;EAMJ;EAJI;;IACE,YAAA;IACA,4BAAA;IAAA,uBAAA;EAON;EAHE;;IAEE,wBAAA;IAAA,mBAAA;EAKJ;EAHI;;IACE,YAAA;IACA,4BAAA;IAAA,uBAAA;EAMN;EAFE;IAAqB,0BAAA;EAKvB;EAJE;IAAyB,WAAA;IAAa,YAAA;IAAc,cAAA;EAStD;EARE;IAAuB,eAAA;EAWzB;EAVE;IAAoB,eAAA;IAAiB,gBAAA;EAcvC;EAbE;IAAsB,YAAA;IAAc,eAAA;EAiBtC;EAfE;IAAc,iBAAA;EAkBhB;EAjBE;IAAoB,gBAAA;IAAkB,eAAA;EAqBxC;EApBE;IAAoB,cAAA;EAuBtB;EArBE;IAAa,gBAAA;EAwBf;EAxBiC;IAAW,eAAA;EA2B5C;EA1BE;IAAmB,eAAA;EA6BrB;EA5BE;IAAwB,eAAA;IAAiB,iCAAA;EAgC3C;EA/BE;IAAiB,yBAAA;EAkCnB;EAjCE;IAAoB,iBAAA;EAoCtB;EAnCE;IAAmB,eAAA;EAsCrB;EArCE;IAAoB,eAAA;EAwCtB;AACF;AAtCA,4BAAA","sourcesContent":["\r\n\r\n// About @use https://stackoverflow.com/questions/66365150/when-importing-a-file-with-use-then-error-undefined-mixin/66366316#66366316\r\n\r\n/* Side bar */\r\n@mixin side-component($width-val: 400px) {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex-shrink: 0;\r\n    flex-grow: 0;\r\n    width: $width-val;\r\n}\r\n\r\n@mixin main-component($width-val: 1200px) {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex-shrink: 0;\r\n    flex-grow: 0;\r\n    width: $width-val;\r\n}\r\n\r\n/* Add shadows into the element */\r\n@mixin with-shadow($z-index-val: 20) {\r\n    box-shadow: 0 8px 12px 1px rgb(29 17 51 / 4%), 0 3px 16px 2px rgb(9 32 77 / 12%),\r\n        0 5px 10px -3px rgb(29 17 51 / 12%);\r\n    z-index: $z-index-val;\r\n}\r\n\r\n/* Container with a column direction */\r\n.row-layout {\r\n    display: flex;\r\n    flex-direction: row;\r\n    height: 100%;\r\n}\r\n\r\n/* Container with a column direction */\r\n.column-layout {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n}\r\n\r\n/* Item style for empty lists */\r\n.notification-label {\r\n    display: flex;\r\n    justify-content: center;\r\n    padding: 1rem;\r\n    gap: 8px;\r\n}\r\n","@use '/src/custom-style.scss';\r\n\r\n.left-panel-tree {\r\n  width: 100%;\r\n  margin: 0px;\r\n  padding: 0px;\r\n  background: var(--ion-card-background);\r\n}\r\n\r\nion-item {\r\n    height: fit-content;\r\n    font-size: small;\r\n    padding: 0px;\r\n    margin: 0px;\r\n}\r\n\r\n// ─── Info Accordion Header ─────────────────────────────────────────────────\r\n\r\n.info-header-item {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  padding: 7px 8px 7px 6px;\r\n  gap: 8px;\r\n  background: rgba(var(--ion-color-primary-rgb), 0.06);\r\n  border-left: 3px solid var(--ion-color-primary);\r\n  border-bottom: 1px solid rgba(var(--ion-color-primary-rgb), 0.15);\r\n  cursor: pointer;\r\n  overflow: hidden;\r\n}\r\n\r\n.info-caret {\r\n  flex: 0 0 16px;\r\n  font-size: 14px;\r\n  color: var(--ion-color-primary);\r\n}\r\n\r\n.info-header-icon-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex: 0 0 26px;\r\n  width: 26px;\r\n  height: 26px;\r\n  border-radius: 6px;\r\n  background: rgba(var(--ion-color-primary-rgb), 0.14);\r\n\r\n  ion-icon {\r\n    font-size: 14px;\r\n    color: var(--ion-color-primary);\r\n  }\r\n}\r\n\r\n.info-header-texts {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1px;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.info-header-eyebrow {\r\n  font-size: 9px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.08em;\r\n  color: var(--ion-color-primary);\r\n  white-space: nowrap;\r\n}\r\n\r\n.info-header-name {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: var(--ion-color-dark);\r\n  white-space: nowrap;\r\n}\r\n\r\n.info-header-action {\r\n  flex: 0 0 auto;\r\n  height: 24px;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  --padding-start: 8px;\r\n  --padding-end: 8px;\r\n  margin: 0;\r\n}\r\n\r\n// ─── Info Form Content ─────────────────────────────────────────────────────\r\n\r\n.info-form-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n  padding: 8px;\r\n  background: rgba(var(--ion-color-light-rgb), 0.4);\r\n  border-bottom: 1px solid rgba(var(--ion-color-primary-rgb), 0.08);\r\n}\r\n\r\n.info-fields-row {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 5px;\r\n}\r\n\r\n.info-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  background: var(--ion-background-color, #fff);\r\n  border: 1px solid rgba(var(--ion-text-color-rgb), 0.1);\r\n  border-radius: 6px;\r\n  padding: 5px 8px 5px;\r\n  border-left: 3px solid rgba(var(--ion-color-primary-rgb), 0.35);\r\n}\r\n\r\n.info-field-label {\r\n  font-size: 8px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.07em;\r\n  color: var(--ion-color-medium);\r\n  line-height: 1;\r\n}\r\n\r\n.info-field-input {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  --padding-start: 0;\r\n  --padding-end: 0;\r\n  --padding-top: 0;\r\n  --padding-bottom: 0;\r\n  --color: var(--ion-color-dark);\r\n  min-height: 22px;\r\n}\r\n\r\n// ─── Defaults Section ──────────────────────────────────────────────────────\r\n\r\n.defaults-section {\r\n  padding: 6px 8px;\r\n  background: rgba(var(--ion-color-light-rgb), 0.5);\r\n  border-bottom: 1px solid rgba(var(--ion-text-color-rgb), 0.07);\r\n\r\n  .info-fields-row {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n.defaults-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  font-size: 9px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.07em;\r\n  color: var(--ion-color-medium);\r\n  margin-bottom: 5px;\r\n\r\n  ion-icon {\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n\r\nion-grid {\r\n  height: 100%;\r\n  width: 100%;\r\n  margin: 0px;\r\n  padding: 0px;\r\n  background: var(--ion-card-background);\r\n}\r\n\r\nion-col {\r\n  height: 100%;\r\n  width: 100%;\r\n  padding-left: var(--spacing-small);\r\n  padding-right: var(--spacing-small);\r\n}\r\n\r\nion-row {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\nion-input.smallItem {\r\n  font-weight: 500;\r\n  width: 100%;\r\n  font-size: var(--font-size-small);\r\n  --color: var(--ion-text-color);\r\n}\r\n\r\nion-input.largeItem {\r\n  font-weight: 500;\r\n  font-size: var(--font-size-small);\r\n  width: 100%;\r\n  --color: var(--ion-text-color);\r\n}\r\n\r\n// ─── Stage Indicator Tabs ──────────────────────────────────────────────────\r\n\r\n.stage-indicator {\r\n  display: flex;\r\n  width: 100%;\r\n  background: var(--ion-card-background);\r\n  border-bottom: 1px solid var(--ion-border-color, rgba(var(--ion-text-color-rgb), 0.12));\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 10;\r\n}\r\n\r\n.stage-tab {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 2px;\r\n  padding: 6px 4px;\r\n  background: transparent;\r\n  border: none;\r\n  border-bottom: 3px solid transparent;\r\n  cursor: pointer;\r\n  font-size: var(--font-size-xx-small);\r\n  color: var(--ion-color-medium);\r\n  transition: color 0.15s, border-color 0.15s, background 0.15s;\r\n  position: relative;\r\n\r\n  ion-icon {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .stage-tab-label {\r\n    font-size: var(--font-size-xx-small);\r\n    font-weight: 500;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .stage-tab-count {\r\n    position: absolute;\r\n    top: 3px;\r\n    right: 6px;\r\n    background: var(--ion-color-medium);\r\n    color: var(--ion-color-medium-contrast);\r\n    border-radius: 8px;\r\n    font-size: 9px;\r\n    font-weight: 700;\r\n    padding: 0 4px;\r\n    line-height: 14px;\r\n    min-width: 14px;\r\n    text-align: center;\r\n  }\r\n\r\n  &.active {\r\n    color: var(--ion-text-color);\r\n    border-bottom-color: currentColor;\r\n    background: var(--ion-card-background);\r\n  }\r\n\r\n  &.departure-tab.active {\r\n    color: rgb(255, 89, 94);\r\n    .stage-tab-count { background: rgb(255, 89, 94); color: #fff; }\r\n  }\r\n  &.mission-tab.active {\r\n    color: rgb(138, 201, 38);\r\n    .stage-tab-count { background: rgb(138, 201, 38); color: #fff; }\r\n  }\r\n  &.arrival-tab.active {\r\n    color: rgb(50, 108, 235);\r\n    .stage-tab-count { background: rgb(50, 108, 235); color: #fff; }\r\n  }\r\n}\r\n\r\n// ─── Stage Sections ────────────────────────────────────────────────────────\r\n\r\n.stage-section {\r\n  border-bottom: 1px solid var(--ion-border-color, rgba(var(--ion-text-color-rgb), 0.08));\r\n}\r\n\r\n.stage-section-header {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 4px var(--spacing-small);\r\n  font-size: var(--font-size-xx-small);\r\n  font-weight: 700;\r\n  letter-spacing: 0.04em;\r\n  text-transform: uppercase;\r\n  cursor: pointer;\r\n\r\n  .stage-section-title {\r\n    flex: 1;\r\n  }\r\n\r\n  &.departure-header {\r\n    color: rgb(255, 89, 94);\r\n    border-left: 3px solid rgb(255, 89, 94);\r\n    background: rgba(255, 89, 94, 0.06);\r\n  }\r\n  &.mission-header {\r\n    color: rgb(138, 201, 38);\r\n    border-left: 3px solid rgb(138, 201, 38);\r\n    background: rgba(138, 201, 38, 0.06);\r\n  }\r\n  &.arrival-header {\r\n    color: rgb(50, 108, 235);\r\n    border-left: 3px solid rgb(50, 108, 235);\r\n    background: rgba(50, 108, 235, 0.06);\r\n  }\r\n\r\n  .add-branch-btn {\r\n    --padding-start: 4px;\r\n    --padding-end: 4px;\r\n    height: 24px;\r\n  }\r\n}\r\n\r\n// ─── Branch Headers ────────────────────────────────────────────────────────\r\n\r\n.branch-header {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 2px 4px 2px 8px;\r\n  cursor: pointer;\r\n  font-size: var(--font-size-xx-small);\r\n  border-left: 3px solid transparent;\r\n  transition: background 0.12s, border-color 0.12s;\r\n\r\n  &:hover {\r\n    background: rgba(var(--ion-text-color-rgb), 0.04);\r\n  }\r\n\r\n  .expand-icon {\r\n    font-size: 10px;\r\n    color: var(--ion-color-medium);\r\n    flex-shrink: 0;\r\n    margin-right: 4px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .branch-label {\r\n    flex: 1;\r\n    font-size: var(--font-size-xx-small);\r\n    font-weight: 600;\r\n    font-style: italic;\r\n    --color: var(--ion-text-color);\r\n    --padding-start: 0;\r\n  }\r\n\r\n  &.active-branch {\r\n    &.departure-branch {\r\n      border-left-color: rgb(255, 89, 94);\r\n      background: rgba(255, 89, 94, 0.1);\r\n    }\r\n    &.arrival-branch {\r\n      border-left-color: rgb(50, 108, 235);\r\n      background: rgba(50, 108, 235, 0.1);\r\n    }\r\n  }\r\n}\r\n\r\n// ─── Branch & Fork Items ───────────────────────────────────────────────────\r\n\r\n.branch-items {\r\n  padding-left: 12px;\r\n}\r\n\r\n.fork-group {\r\n  margin: 2px 0;\r\n\r\n  .fork-header {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 3px 4px;\r\n    cursor: pointer;\r\n    font-size: var(--font-size-xx-small);\r\n    border-radius: var(--border-radius-small);\r\n    gap: 4px;\r\n\r\n    &:hover {\r\n      background: rgba(var(--ion-text-color-rgb), 0.04);\r\n    }\r\n\r\n    ion-icon {\r\n      font-size: 10px;\r\n      color: var(--ion-color-medium);\r\n      flex-shrink: 0;\r\n    }\r\n\r\n    .fork-label {\r\n      flex: 1;\r\n      font-weight: 600;\r\n      font-size: var(--font-size-xx-small);\r\n      color: var(--ion-text-color);\r\n    }\r\n\r\n    ion-button {\r\n      height: 22px;\r\n      --padding-start: 2px;\r\n      --padding-end: 2px;\r\n    }\r\n  }\r\n\r\n  &.departure-fork .fork-header { border-left: 2px dashed rgba(255, 89, 94, 0.5); }\r\n  &.mission-fork .fork-header   { border-left: 2px dashed rgba(138, 201, 38, 0.5); }\r\n  &.arrival-fork .fork-header   { border-left: 2px dashed rgba(50, 108, 235, 0.5); }\r\n}\r\n\r\n.fork-items {\r\n  padding-left: 14px;\r\n}\r\n\r\n// ─── Waypoint Rows ─────────────────────────────────────────────────────────\r\n\r\n.waypoint-row {\r\n  border-bottom: 1px solid var(--ion-border-color, rgba(var(--ion-text-color-rgb), 0.06));\r\n  transition: background 0.1s;\r\n\r\n  &:hover {\r\n    background: rgba(var(--ion-text-color-rgb), 0.03);\r\n  }\r\n\r\n  &.departure-wp { border-left: 2px solid rgba(255, 89, 94, 0.3); }\r\n  &.mission-wp   { border-left: 2px solid rgba(138, 201, 38, 0.3); }\r\n  &.arrival-wp   { border-left: 2px solid rgba(50, 108, 235, 0.3); }\r\n\r\n  &.fork-wp {\r\n    border-left-width: 2px;\r\n    border-left-style: dashed;\r\n    opacity: 0.92;\r\n  }\r\n}\r\n\r\n// ─── Empty State ───────────────────────────────────────────────────────────\r\n\r\n.empty-stage-hint {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 8px var(--spacing-small);\r\n  font-size: var(--font-size-xx-small);\r\n  color: var(--ion-color-medium);\r\n  font-style: italic;\r\n\r\n  ion-icon {\r\n    font-size: 14px;\r\n    flex-shrink: 0;\r\n  }\r\n}\r\n\r\n/** Media queries **/\r\n\r\n/*#region Small Screens*/\r\n\r\n/* Styles for screens smaller than 800px wide or smaller than 550px high */\r\n@media (max-width: 599px) {\r\n  .stage-tab {\r\n    padding: 4px 2px;\r\n    .stage-tab-label { display: none; }\r\n    ion-icon { font-size: 16px; }\r\n  }\r\n\r\n  .stage-section-header {\r\n    padding: 3px var(--spacing-small);\r\n    font-size: 9px;\r\n  }\r\n\r\n  .info-field { padding: 4px 6px; }\r\n  .info-field-input { min-height: 18px; font-size: 11px; }\r\n  .defaults-section { padding: 4px 6px; }\r\n}\r\n\r\n/*#endregion Small Screens*/\r\n\r\n/*#region Medium Screens*/\r\n\r\n  /* Styles for medium screens with min-width of 800px and min-height of 550px */\r\n  @media (min-width: 600px) and (max-width: 1023px) {\r\n\r\n    ion-accordion.accordion-collapsed ion-item[slot=\"header\"],\r\n    ion-accordion.accordion-collapsing ion-item[slot=\"header\"] {\r\n      height: fit-content;\r\n\r\n      &::part(native) {\r\n        height: 34px;\r\n        min-height: fit-content;\r\n      }\r\n    }\r\n\r\n    ion-accordion.accordion-expanded ion-item[slot=\"header\"],\r\n    ion-accordion.accordion-expanding ion-item[slot=\"header\"] {\r\n      height: fit-content;\r\n\r\n      &::part(native) {\r\n        height: 34px;\r\n        min-height: fit-content;\r\n      }\r\n    }\r\n\r\n    .info-field { padding: 5px 8px; }\r\n    .info-field-input { min-height: 22px; font-size: 13px; }\r\n    .stage-section-header { font-size: 10px; }\r\n    .branch-header { padding: 3px 4px 3px 10px; }\r\n    .defaults-section { padding: 6px 8px; }\r\n  }\r\n\r\n/*#endregion Medium Screens*/\r\n\r\n/*#region Larger Screens*/\r\n\r\n  /* Styles for screens larger than 1000px wide and 600px high */\r\n  @media (min-width: 1024px) {\r\n\r\n    ion-accordion.accordion-collapsed ion-item[slot=\"header\"],\r\n    ion-accordion.accordion-collapsing ion-item[slot=\"header\"] {\r\n      height: fit-content;\r\n\r\n      &::part(native) {\r\n        height: 40px;\r\n        min-height: fit-content;\r\n      }\r\n    }\r\n\r\n    ion-accordion.accordion-expanded ion-item[slot=\"header\"],\r\n    ion-accordion.accordion-expanding ion-item[slot=\"header\"] {\r\n      height: fit-content;\r\n\r\n      &::part(native) {\r\n        height: 40px;\r\n        min-height: fit-content;\r\n      }\r\n    }\r\n\r\n    .info-header-inner { padding: 8px 10px 8px 12px; }\r\n    .info-header-icon-wrap { width: 30px; height: 30px; flex: 0 0 30px; }\r\n    .info-header-eyebrow { font-size: 10px; }\r\n    .info-header-name { font-size: 13px; max-width: 150px; }\r\n    .info-header-action { height: 28px; font-size: 12px; }\r\n\r\n    .info-field { padding: 6px 10px; }\r\n    .info-field-input { min-height: 26px; font-size: 14px; }\r\n    .info-field-label { font-size: 9px; }\r\n\r\n    .stage-tab { padding: 8px 6px; ion-icon { font-size: 16px; } }\r\n    .stage-tab-label { font-size: 11px; }\r\n    .stage-section-header { font-size: 11px; padding: 5px var(--spacing-small); }\r\n    .branch-header { padding: 4px 6px 4px 12px; }\r\n    .defaults-section { padding: 8px 10px; }\r\n    .defaults-header { font-size: 10px; }\r\n    .empty-stage-hint { font-size: 11px; }\r\n  }\r\n\r\n/*#endregion Larger Screens*/\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
